// Jauge circulaire de billetterie (SVG, animation douce)
export const CircularGauge = ({ vendues, objectif, couleur, libelle, derniereMaj, testId }) => {
  const rayon = 70;
  const circonference = 2 * Math.PI * rayon;
  const pct = objectif ? Math.min(100, (vendues / objectif) * 100) : 0;
  const offset = circonference - (pct / 100) * circonference;
  const restantes = Math.max(0, objectif - vendues);

  return (
    <div className="flex flex-col items-center gap-3" data-testid={testId}>
      <div className="relative">
        <svg width="184" height="184" viewBox="0 0 184 184" className="-rotate-90">
          <circle cx="92" cy="92" r={rayon} fill="none" strokeWidth="14" className="stroke-muted" />
          <circle
            cx="92"
            cy="92"
            r={rayon}
            fill="none"
            strokeWidth="14"
            strokeLinecap="round"
            stroke={couleur}
            strokeDasharray={circonference}
            strokeDashoffset={offset}
            className="jauge-cercle"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-serif text-4xl font-bold leading-none" data-testid={`${testId}-vendues`}>
            {vendues.toLocaleString("fr-BE")}
          </span>
          <span className="text-xs text-muted-foreground mt-1">/ {objectif.toLocaleString("fr-BE")} places</span>
          <span className="text-sm font-semibold mt-1" style={{ color: couleur }}>
            {pct.toFixed(1)} %
          </span>
        </div>
      </div>
      <div className="text-center">
        <p className="font-medium">{libelle}</p>
        <p className="text-xs text-muted-foreground">
          {restantes > 0 ? `${restantes.toLocaleString("fr-BE")} places restantes` : "Sold-out !"}
        </p>
        {derniereMaj && (
          <p className="text-[11px] text-muted-foreground/70 mt-0.5">Mis à jour le {derniereMaj}</p>
        )}
      </div>
    </div>
  );
};
